import type { QuoteCancelRequest } from 'apiConnector/quote';
import { quoteApiConnector } from 'apiConnector/quote';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, ignoreElements, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';

export function cancelQuoteEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('ORDERS_BASKET_FORM_QUOTE_CANCELED'),
      mergeMap(({ formId, quoteId }) => {
        const request: QuoteCancelRequest = {
          negotiationId: formId,
          quoteId,
        };

        return quoteApiConnector(httpClient)
          .cancelQuote(request)
          .pipe(
            ignoreElements(),
            catchError(() => {
              return EMPTY;
            }),
          );
      }),
    );
}
